import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Fallback } from 'router/Fallback';
import { RequireAuth } from 'router/RequireAuth';

const AccountPage = lazy(() => import('pages/account/AccountContainer'));
const AccountDeletePage = lazy(() => import('pages/account/AccountRemoval'));
const AccountDeleteConfirmedPage = lazy(() => import('pages/account/AccountRemovalConfirmation'));
const AccountRecovery = lazy(() => import('pages/account/AccountRecovery'));
const AccountEmailConfirmation = lazy(() => import('pages/account/AccountEmailConfirmation'));
const AccountEmailVerification = lazy(() => import('pages/account/AccountEmailVerification'));

export const AccountRoutes = [
  {
    path: 'account',
    element: (
      <Suspense fallback={<Fallback />}>
        <RequireAuth>
          <Outlet />
        </RequireAuth>
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Fallback />}>
            <AccountPage />
          </Suspense>
        ),
      },
      {
        path: 'delete',
        element: (
          <Suspense fallback={<Fallback />}>
            <AccountDeletePage />
          </Suspense>
        ),
      },
    ],
  },
  {
    // Public: these are reached while signed out — the confirmation page is shown
    // right after an email change signs the user out, and the token routes are
    // opened from links in the user's inbox. Guarding them with RequireAuth would
    // bounce the user to /signin and the verification would never run.
    path: 'account/email',
    children: [
      {
        path: 'confirmation',
        element: (
          <Suspense fallback={<Fallback />}>
            <AccountEmailConfirmation />
          </Suspense>
        ),
      },
      {
        path: 'verify/:token',
        element: (
          <Suspense fallback={<Fallback />}>
            <AccountEmailVerification />
          </Suspense>
        ),
      },
      {
        path: 'confirm/:token',
        element: (
          <Suspense fallback={<Fallback />}>
            <AccountEmailVerification />
          </Suspense>
        ),
      },
      {
        path: 'recover/:token',
        element: (
          <Suspense fallback={<Fallback />}>
            <AccountEmailVerification />
          </Suspense>
        ),
      },
    ],
  },
  {
    // Public: an account-recovery token link, opened from the user's inbox while
    // signed out. Redirects to /signin once the account is restored.
    path: 'account/recover/:token',
    element: (
      <Suspense fallback={<Fallback />}>
        <AccountRecovery />
      </Suspense>
    ),
  },
  {
    path: 'account/delete-confirmed',
    element: (
      <Suspense fallback={<Fallback />}>
        <AccountDeleteConfirmedPage />
      </Suspense>
    ),
  },
];
